var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        key: "submit-block",
        staticClass:
          "page-block mb-5 d-flex justify-content-start align-items-start terms__heading"
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.isMarketingConsentChecked,
              expression: "isMarketingConsentChecked"
            }
          ],
          staticClass: "terms-checkbox",
          attrs: { id: "marketing-checkbox", type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.isMarketingConsentChecked)
              ? _vm._i(_vm.isMarketingConsentChecked, null) > -1
              : _vm.isMarketingConsentChecked
          },
          on: {
            change: function($event) {
              var $$a = _vm.isMarketingConsentChecked,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.isMarketingConsentChecked = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.isMarketingConsentChecked = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.isMarketingConsentChecked = $$c
              }
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c(
            "label",
            {
              class: { small: _vm.small },
              attrs: { for: "marketing-checkbox" }
            },
            [_vm._v(_vm._s(_vm.$t("shared.marketing_consent.check_box_text")))]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }